import { isCommonSicaRoute, isSuperAdminOnlySicaRoute } from './sica-route-catalog';
import { hasSuperAdminRole, hasSuperAdminSettingsAccess } from './super-admin-access.util';
import { User } from 'app/core/user/user.types';

/** Compare the received TERA link exactly, ignoring case only. */
export function hasPagePermission(user: User, link: string): boolean {
    if (isSuperAdminOnlySicaRoute(link)) {
         return hasSuperAdminRole();
    }
    if (hasSuperAdminSettingsAccess(link)) {
        return true;
    }
    return isCommonSicaRoute(link) || !!link && (user?.user_UserProfiles || []).some(profile =>
        (profile.userProfile?.permissions || []).some(permission =>
            !!permission.pageRoute && permission.pageRoute.toLowerCase() == link.toLowerCase()
        )
    );
}
